import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor", "input", "select", "textarea", "trueIcon", "falseIcon"]
  static values  = {
    url:   String,
    model: String,
    field: String,
    type:  { type: String, default: "text" }
  }

  edit() {
    let el
    if (this.typeValue === "select" || this.typeValue === "chosen") {
      el = this.selectTarget
    } else if (this.typeValue === "textarea") {
      el = this.textareaTarget
    } else {
      el = this.inputTarget
    }
    if ((this.typeValue === "select" || this.typeValue === "chosen") && el.multiple) {
      const ids = JSON.parse(this.displayTarget.dataset.value || "[]").map(String)
      Array.from(el.options).forEach(opt => { opt.selected = ids.includes(opt.value) })
    } else if (this.typeValue !== "chosen") {
      el.value = this.displayTarget.dataset.value
    }
    this.displayTarget.classList.add("d-none")
    this.editorTarget.classList.remove("d-none")
    if (this.typeValue === "chosen") {
      const $el = $(el)
      if (!$el.data("chosen")) {
        $el.chosen({ width: "200px", search_contains: true })
      }
      $el.trigger("chosen:updated")
      $el.trigger("chosen:open")
    } else {
      el.focus()
      if (this.typeValue === "text") el.select()
    }
  }

  cancel() {
    this.displayTarget.classList.remove("d-none")
    this.editorTarget.classList.add("d-none")
    if (this.hasInputTarget)  this.inputTarget.classList.remove("is-invalid")
    if (this.hasSelectTarget) this.selectTarget.classList.remove("is-invalid")
    if (this.typeValue === "chosen" && this.hasSelectTarget) {
      $(this.selectTarget).trigger("chosen:close")
    }
  }

  keydown(event) {
    if (this.typeValue !== "textarea" && event.key === "Enter") { event.preventDefault(); this.save() }
    if (event.key === "Escape") { this.cancel() }
  }

  async toggle() {
    const current  = this.displayTarget.dataset.value === "true"
    const newValue = !current
    const ok = await this.send(newValue)
    if (ok) {
      this.displayTarget.dataset.value = String(newValue)
      this.trueIconTarget.classList.toggle("d-none", !newValue)
      this.falseIconTarget.classList.toggle("d-none", newValue)
    }
  }

  async save() {
    const el = (this.typeValue === "select" || this.typeValue === "chosen") ? this.selectTarget :
               this.typeValue === "textarea" ? this.textareaTarget : this.inputTarget
    let value, label
    if ((this.typeValue === "select" || this.typeValue === "chosen") && el.multiple) {
      const selected = Array.from(el.selectedOptions)
      value = selected.map(o => o.value)
      label = selected.map(o => o.text).join(", ")
      this.displayTarget.dataset.value = JSON.stringify(value)
    } else if (this.typeValue === "select") {
      value = el.value
      label = el.options[el.selectedIndex].text
      this.displayTarget.dataset.value = value
    } else {
      value = el.value.trim()
      label = value
      this.displayTarget.dataset.value = value
    }
    const ok = await this.send(value)
    if (ok) {
      this.displayTarget.querySelector("[data-inline-edit-text]").textContent = label
      this.cancel()
    } else {
      el.classList.add("is-invalid")
    }
  }

  async send(value) {
    const body = { [this.modelValue]: { [this.fieldValue]: value } }
    const response = await fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept":       "application/json"
      },
      body: JSON.stringify(body)
    })
    return response.ok
  }
}
